export var BICTypeMap = [
    { value: "ABNANL2A", label: "ABN AMRO" },
    { value: "ASNBNL21", label: "ASN Bank" },
    { value: "BUNQNL2A", label: "Bunq" },
    { value: "INGBNL2A", label: "ING" },
    { value: "KNABNL2H", label: "Knab" },
    { value: "RABONL2U", label: "Rabobank" },
    { value: "RBRBNL21", label: "RegioBank" },
    { value: "SNSBNL2A", label: "SNS Bank" },
    { value: "TRIONL2U", label: "Triodos Bank" },
    { value: "FVLBNL22", label: "Van Lanschot Bankiers" },
    { value: "MOYONL21", label: "Moneyou" },
];
